import React from "react";

export function AboutUsX() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M8.77977 6.91003L16.4598 17.02H15.2698L7.50977 6.91003H8.77977Z" fill="#6C7085" />
      <path d="M17 2H7C5.67392 2 4.40215 2.52678 3.46447 3.46447C2.52678 4.40215 2 5.67392 2 7V17C2 18.3261 2.52678 19.5979 3.46447 20.5355C4.40215 21.4732 5.67392 22 7 22H17C18.3261 22 19.5979 21.4732 20.5355 20.5355C21.4732 19.5979 22 18.3261 22 17V7C22 5.67392 21.4732 4.40215 20.5355 3.46447C19.5979 2.52678 18.3261 2 17 2ZM14.68 18.3L11.3 13.9L7.42 18.3H5.28L10.28 12.59L5 5.7H9.43L12.49 9.7L16 5.7H18.14L13.48 11L19 18.3H14.68Z" fill="#6C7085" />
    </svg>
  );
}
